import { StreamingType } from '@/store/streaming';

import { Button } from '@nf/ui';

interface StreamingButtonProps {
	type: StreamingType;
	isActive: boolean;
	isDesktop: boolean;
	Icon: React.ComponentType;
	DesktopIcon: React.ComponentType;
	onClick: (type: StreamingType) => void;
}

export const StreamingButton = ({
	type,
	isActive,
	isDesktop, 
	Icon, 
	DesktopIcon, 
	onClick, 
}: StreamingButtonProps) => {
	const handleClick = (type: StreamingType) => () => {
		onClick(type);
	}

	return (
		<Button
			data-active={isActive}
			variant="icon"
			onClick={handleClick(type)}
		>
			{isDesktop ? <DesktopIcon /> : <Icon />}
		</Button>
	);
};